import { lazy } from 'react'

export const BonusHistoryLazy = lazy(() => import('./BonusHistory'))
